import script from "./SubscriptionSelected.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionSelected.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionSelected.vue?vue&type=style&index=0&id=6f290883&scoped=true&lang=css"
script.__scopeId = "data-v-6f290883"

export default script